import React from 'react';
import { LayersIcon, StarIcon, UsersIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { socialStats, topReviews } from '../data/content';
const icons = {
  users: UsersIcon,
  layers: LayersIcon,
  star: StarIcon
};
function Stars() {
  return <span className="flex items-center gap-0.5" aria-label="5 out of 5 stars" data-id="element-189" data-mp="36xy78q5xz8be">
      {[0, 1, 2, 3, 4].map(index => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-190" data-mp="3f4sia1fgdfn" />)}
    </span>;
}
export function SocialProof() {
  return <section aria-label="Coach results and reviews" className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-191" data-mp="3pupj4ej5ml5f">
      <div className="mx-auto w-full max-w-6xl" data-id="element-192" data-mp="3usr2l0khsmhf">
        <Reveal data-id="element-193" data-mp="3urfzl2yvfird">
          <div className="grid gap-6 sm:grid-cols-3" data-id="element-194" data-mp="mdplk7mvpsvx">
            {socialStats.map(stat => {
            const Icon = icons[stat.icon as keyof typeof icons];
            return <div key={stat.label} className="flex items-center justify-center gap-4 rounded-card border border-navy/10 bg-blush px-6 py-6" data-id="element-195" data-mp="r6acn1eehrvr">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-196" data-mp="1p8x9qar2l07p">
                    <Icon className="h-5 w-5 text-cheer" aria-hidden="true" data-id="element-197" data-mp="1z8xwk6o5dygn" />
                  </span>
                  <span className="text-left" data-id="element-198" data-mp="2d02n8j9jfgeu">
                    <span className="block font-display text-2xl font-extrabold tracking-tight text-navy" data-id="element-199" data-mp="2cz1ewmjwp80t">
                      {stat.value}
                    </span>
                    <span className="block text-xs font-semibold uppercase tracking-wider text-navy/60" data-id="element-200" data-mp="2mz1v3zmhb80s">
                      {stat.label}
                    </span>
                  </span>
                </div>;
          })}
          </div>
        </Reveal>

        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-201" data-mp="nlec0lcoo4ie">
          {topReviews.map((review, index) => <Reveal key={review.name} delay={index * 0.06} className="h-full" data-id="element-202" data-mp="1d9tib8noxw2x" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-card border border-navy/10 bg-white p-6 shadow-card transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-203" data-mp="1dbwi2kenb3ku">
                <Stars data-id="element-204" data-mp="1m8x10biy49gw" />
                <blockquote className="mt-4 text-[15px] leading-relaxed text-navy/80" data-id="element-205" data-mp="1mcktr8gkgruk">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-6" data-id="element-206" data-mp="1w7mlmc28880u">
                  <span className="block text-sm font-bold text-navy" data-id="element-207" data-mp="209zpsw1brxvi">{review.name}</span>
                  <span className="block text-xs text-navy/55" data-id="element-208" data-mp="207n2e3cssvb2">{review.role}</span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}